import React, { MouseEventHandler, ReactNode } from 'react'

const buttonVariants = {
  primary: {
    enabled:
      'rounded-md w-1/2 h-12 bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600',
    disabled:
      'rounded-md w-1/2 h-12 bg-blue-50 px-3 py-2 text-sm font-semibold text-blue-300 shadow-sm cursor-not-allowed text-muted-foreground',
  },
  secondary: {
    enabled:
      'rounded-md w-1/2 h-12 bg-blue-50 px-3 py-2 text-sm font-semibold text-blue-600 shadow-sm hover:bg-blue-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600',
    disabled:
      'rounded-md w-1/2 h-12 bg-blue-50 px-3 py-2 text-sm font-semibold text-blue-300 shadow-sm text-muted-foreground cursor-not-allowed',
  },
}

export default function FormButton(props: {
  children: ReactNode
  id?: string
  variant: keyof typeof buttonVariants
  disabled: boolean
  onClick?: MouseEventHandler
  type: 'button' | 'submit'
}) {
  const style = props.disabled ? 'disabled' : 'enabled'

  return (
    <button
      id={props.id}
      type={props.type}
      className={buttonVariants[props.variant][style]}
      onClick={(event) => {
        if (!props.disabled && props.onClick) {
          props.onClick(event)
        }
      }}
      disabled={props.disabled}
    >
      {props.children}
    </button>
  )
}
